import { http } from '@/http/axios.js';

export function getOverviewListAPI(params) {
  return http({
    url: '/adminapi/bi/product/overview/page',
    method: 'get',
    params
  })
}

export function getDayListAPI(params) {
  return http({
    url: '/adminapi/bi/product/day/page',
    method: 'get',
    params
  })
}

export function getMonthListAPI(params) {
  return http({
    url: '/adminapi/bi/product/month/page',
    method: 'get',
    params
  })
}
